(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow-mande"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.querySelectorAll('.mande-slideshow').forEach(function(el) {
    var track = el.querySelector('.mande-slideshow__track');
    var slides = el.querySelectorAll('.mande-slideshow__slide');
    var dots = el.querySelectorAll('.mande-slideshow__dot');
    var total = slides.length;
    var current = 0;
    var auto = parseInt(el.dataset.autoplay) || 0;
    var timer;

    function goTo(n) {
      current = (n + total) % total;
      track.style.transform = 'translateX(-' + (current * 100) + '%)';
      dots.forEach(function(d, i) {
        d.classList.toggle('is-active', i === current);
      });
    }

    el.querySelector('.mande-slideshow__arrow--prev').addEventListener('click', function() { goTo(current - 1); reset(); });
    el.querySelector('.mande-slideshow__arrow--next').addEventListener('click', function() { goTo(current + 1); reset(); });
    dots.forEach(function(d, i) { d.addEventListener('click', function() { goTo(i); reset(); }); });

    function reset() {
      if (!auto) return;
      clearInterval(timer);
      timer = setInterval(function() { goTo(current + 1); }, auto);
    }

    goTo(0);
    if (auto) timer = setInterval(function() { goTo(current + 1); }, auto);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
